export default {
  bind(el, binding) {
    const dom = binding.value.dom;
    el.onmousedown = e => {
      e = e || window.event;
      const y = e.pageY || e.clientY + scrollY;
      const h = dom.offsetHeight || 0;

      const transi = window.getComputedStyle(dom, null).transition;
      dom.style.transition = "all 0s";
      document.onmousemove = evt => {
        evt = evt || window.event;
        const pageY = evt.pageY || evt.clientY + scrollY;
        dom.style.height = h + pageY - y + "px";
      };
      document.onmouseup = evt => {
        document.onmousemove = null;
        dom.style.transition = transi;
      };
    };
  }
};
